import React from "react";
import { Link } from "react-router-dom";
import { FaHeart, FaRegHeart, FaMapMarkerAlt, FaTag, FaClipboardCheck, FaShareAlt } from "react-icons/fa";
import { connect } from "react-redux";
import * as actions_wish from "../redux/actions/wishActions";
import * as actions_transaction from "../redux/actions/transactionPendingActions";
import { withRouter } from "react-router";
import ModalReportAd from "./ModalReportAd";
import ModalShareAd from "./ModalShareAd";
import ModalAuctionBid from "./ModalAuctionBid";
import ModalCheckout from "./ModalCheckout";
import "./styles/AdDetailAction.css";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";
import { Translate, Localize, I18n } from "react-redux-i18n";
import { AuctionExpirationLabel, getAuctionDaysRemaining } from "../utils/auctionExpirationUtils";

/**
 * <div className="col-md-8">
                        <div className="text-right">
                            <div className="fb-share-button fb_iframe_widget" data-to="https://www.godiway.com/productshow/51305d2776style6dce6d5b889343b5af9c82e" data-layout="button" data-size="small" data-mobile-iframe="false" fb-xfbml-state="rendered" fb-iframe-plugin-query="app_id=1796994160354148&amp;container_width=330&amp;to=https%3A%2F%2Fwww.godiway.com%2Fproductshow%2F51305d27766dce6d5b889343b5af9c82e&amp;layout=button&amp;locale=en_US&amp;mobile_iframe=false&amp;sdk=joey&amp;size=small">
                                <span >
                                    <iframe name="f30aed565b5556" title="fb:share_button Facebook Social Plugin" allowTransparency="true" allowfullscreen="true" scrolling="no" allow="encrypted-media"  src="https://www.facebook.com/v3.2/plugins/share_button.php?app_id=1796994160354148&amp;channel=https%3A%2F%2Fstaticxx.facebook.com%2Fconnect%2Fxd_arbiter.php%3Fversion%3D44%23cb%3Df2ae8e030054882%26domain%3Dwww.godiway.com%26origin%3Dhttps%253A%252F%252Fwww.godiway.com%252Ff6c80ef8b2bb18%26relation%3Dparent.parent&amp;container_width=330&amp;to=https%3A%2F%2Fwww.godiway.com%2Fproductshow%2F51305d27766dce6d5b889343b5af9c82e&amp;layout=button&amp;locale=en_US&amp;mobile_iframe=false&amp;sdk=joey&amp;size=small" className="" width="1000px" height="1000px" frameborder="0">
                                    </iframe>
                                </span>
                            </div>
                        </div>
                    </div>
 */

class AdDetailAction extends React.Component {
  state = {
    open_modal: false,
    open_share_modal: false,
    open_bid_modal: false,
    open_checkout_modal: false,
    submitting: false,
    quantity: 1,
  };

  componentDidMount() {
    // console.log(I18n.t("warning"));
    if (this.props.ad.KindCommerceId === 5)
      this.setState({
        quantity: this.props.ad.Price
      });
  }

  onOpenCloseModal = () => {
    if (JSON.stringify(this.props.user) === "{}") {
      alertify.alert(
        I18n.t("warning"),
        I18n.t("warning_login"),
        function () { }
      );
      return;
    }
    this.setState({ open_modal: !this.state.open_modal });
  };

  onOpenCloseShareModal = () => {
    this.setState({ open_share_modal: !this.state.open_share_modal });
  };

  onOpenBidModal = () => {
    if (JSON.stringify(this.props.user) === "{}") {
      alertify.alert(
        I18n.t("warning"),
        I18n.t("warning_login"),
        function () { }
      );
      return;
    }
    this.setState({ open_bid_modal: true });
  };

  onCloseBidModal = () => {
    this.setState({ open_bid_modal: false });
  };

  onClickBuy = async (event) => {
    event.preventDefault();
    if (JSON.stringify(this.props.user) === "{}") {
      alertify.alert(
        I18n.t("warning"),
        I18n.t("warning_login"),
        function () { }
      );
      return;
    }

    if (Number(this.props.ad.KindCommerceId) === 5) {
      this.onOpenBidModal();
      return;
    }

    const kind = Number(this.props.ad.KindCommerceId);
    if (kind === 1 || kind === 2 || kind === 3) {
      this.setState({ open_checkout_modal: true });
      return;
    }

    await this.createTransaction();
  };

  createTransaction = async (extra = {}) => {
    let params = new FormData();
    params.append("goder_id", this.props.ad.Id);
    params.append("message", "");
    params.append("quantity", this.state.quantity);
    params.append("price", this.state.quantity);
    params.append("id", this.props.user_id);
    if (extra.addressId) {
      params.append("address_id", extra.addressId);
    }
    if (extra.payment) {
      params.append("payment_option", extra.payment);
    }

    await this.props
      .NewTransaction(this.props.token, params)
      .then(() => {
        if (this.props.error_transaction) {
          alertify.warning(I18n.t(this.props.error_transaction));
        }
      });

    this.props.history.push("/transaction/info");
  };

  onCloseCheckout = () => {
    this.setState({ open_checkout_modal: false });
  };

  onConfirmCheckout = async (payload) => {
    this.setState({ submitting: true });
    try {
      await this.createTransaction(payload);
    } finally {
      this.setState({ submitting: false, open_checkout_modal: false });
    }
  };

  handleWish = async (event) => {
    //event.preventDefault();
    if (JSON.stringify(this.props.user) === "{}") {
      alertify.alert(
        I18n.t("warning"),
        I18n.t("warning_login"),
        function () { }
      );
      return;
    }

    await this.props
      .UpdateWishAd(this.props.token, {
        goder_id: this.props.ad.Id,
        id: this.props.user_id,
      })
      .then(() => {
        if (this.props.error) {
          alertify.warning(I18n.t(this.props.error));
        }
      });
  };

  onChangeQuantity = (event) => {
    this.setState({
      ...this.state,
      quantity: event.target.value
    });
  };

  onClickStore = (event) => {
    event.preventDefault();
    if (!this.props.ad?.Store?.Id) return;
    this.props.history.replace(`/marketstore/show/${this.props.ad.Store.Id}`);
  };

  getConditionLabel = () => {
    const conditionId = this.props.ad?.Condition?.Id;
    if (conditionId === "NEW") return I18n.t("ad_new");
    if (conditionId === "USED") return I18n.t("ad_used");
    if (conditionId === "SERVICE") return I18n.t("ad_service");
    return "";
  };

  getCategoryName = () => {
    const category = this.props.ad?.Category;
    return category?.Name || category?.name || "";
  };

  getLocationLabel = () => {
    const { ad, user } = this.props;
    const isLoggedIn = JSON.stringify(user) !== "{}";

    if (isLoggedIn && ad.State) {
      return [ad.State, ad.City].filter(Boolean).join(" - ");
    }

    return ad.Country?.Name || "";
  };

  renderDetailRow = (key, icon, label, value, extra = null) => {
    if (!value) return null;

    return (
      <li className="ad-detail-more__item" key={key}>
        <span className="ad-detail-more__icon" aria-hidden="true">
          {icon}
        </span>
        <div className="ad-detail-more__content">
          <span className="ad-detail-more__label">{label}</span>
          <span className="ad-detail-more__value">
            {value}
            {extra}
          </span>
        </div>
      </li>
    );
  };

  renderMoreDetail = () => {
    const { ad, user } = this.props;
    const isLoggedIn = JSON.stringify(user) !== "{}";
    const categoryName = this.getCategoryName();
    const locationLabel = this.getLocationLabel();
    const conditionLabel = this.getConditionLabel();

    const detailRows = [
      locationLabel &&
        this.renderDetailRow(
          "location",
          <FaMapMarkerAlt />,
          I18n.t("location"),
          locationLabel,
          !isLoggedIn && ad.Country?.Flag ? (
            <img
              src={ad.Country.Flag}
              className="ad-detail-more__flag"
              alt=""
            />
          ) : null
        ),
      conditionLabel &&
        this.renderDetailRow(
          "condition",
          <FaClipboardCheck />,
          I18n.t("ad_condition"),
          conditionLabel
        ),
      categoryName &&
        this.renderDetailRow(
          "category",
          <FaTag />,
          I18n.t("ad_category"),
          categoryName
        ),
    ].filter(Boolean);

    if (detailRows.length === 0) {
      return null;
    }

    return (
      <section className="ad-detail-more">
        <h6 className="ad-detail-more__title">
          <Translate value="ad_more_detail" />
        </h6>
        <ul className="ad-detail-more__list">{detailRows}</ul>
      </section>
    );
  };

  render() {
    var link_marketstore = this.props.ad?.Store?.Id
      ? `/marketstore/show/${this.props.ad.Store.Id}`
      : "#";
    //  console.log(this.props.ad.MyInterest);
    var asq_ad = <Translate value="ad_buy" />,
      kindcommerce = "";
    //this.props.ad.KindCommerceId = 5;
    switch (this.props.ad.KindCommerceId) {
      case 1:
        {
          asq_ad = <Translate value="ad_request_donation" />;
          kindcommerce = <Translate value="donation" />;
        }
        break;
      case 2:
        {
          if (this.props.ad.ConditionId === "SERVICE") {
            asq_ad = <Translate value="contact" />;
            kindcommerce = <Translate value="ad_service" />;
          } else {
            asq_ad = <Translate value="ad_buy" />;
            kindcommerce = <Translate value="sale" />;
          }
        }
        break;
      case 3:
        {
          asq_ad = <Translate value="ad_request_exchange" />;
          kindcommerce = <Translate value="exchange" />;
        }
        break;
      case 4:
        {
          asq_ad = <Translate value="ad_request_rent" />;
          kindcommerce = <Translate value="rent" />;
        }
        break;
      case 5:
        {
          asq_ad = <Translate value="ad_bid" />;
          kindcommerce = <Translate value="auction" />;
        }
        break;
      default: break;
    }

    const isAuction = Number(this.props.ad.KindCommerceId) === 5;

    /*  if (this.props.loading)
     return (
 
       <div className="background">
         <div className="refill">
           <div className="bar"></div>
           <div className="mask thick"></div>
           <div className="bar"></div>
           <div className="mask thin"></div>
           <div className="bar medium"></div>
           <div className="mask thick"></div>
           <div className="bar small"></div>
         </div>
       </div>
 
 
     )
 */
    // if (false)
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-12 text-center">
            <h3 className="my-3">{this.props.ad.Name}</h3>
            {Number(this.props.ad.KindCommerceId) === 5 &&
              getAuctionDaysRemaining(this.props.ad) !== null && (
              <p className="ad-detail-expiration">
                <AuctionExpirationLabel item={this.props.ad} />
              </p>
            )}
          </div>
          <div className="col-md-12 text-center">
            <div className="ad-detail-actions">
              <button
                type="button"
                data-toggle="tooltip"
                title={I18n.t("wish_title")}
                aria-label={I18n.t("wish_title")}
                onClick={this.handleWish.bind(this)}
                className={`goder-wish-btn${this.props.ad.MyInterest ? " is-active" : ""}`}
              >
                {this.props.ad.MyInterest ? <FaHeart /> : <FaRegHeart />}
              </button>
              <button
                type="button"
                data-toggle="tooltip"
                title={I18n.t("ad_share_title")}
                aria-label={I18n.t("ad_share_title")}
                onClick={this.onOpenCloseShareModal}
                className="goder-share-btn"
              >
                <FaShareAlt />
              </button>
            </div>
          </div>
        </div>

        {isAuction ? (
          <div className="col-md-12 form-group ad-detail-auction-row">
            <div className="row align-items-center">
              <div className="col-md-8 col-12 ad-detail-auction-row__info">
                <h3 className="italic ad-detail-auction-row__kind">{kindcommerce}:</h3>
                <p className="ad-detail-auction-row__price mb-0">
                  ${this.props.ad.Price}
                  <small>{this.props.ad.Currency}</small>
                </p>
              </div>
              <div className="col-md-4 col-12 text-center goder-button ad-detail-auction-bid">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={this.onOpenBidModal}
                >
                  <b>{asq_ad}</b>
                </button>
              </div>
            </div>
          </div>
        ) : (
          <React.Fragment>
            <div className="text-center mt10">
              <label htmlFor="cantidad">
                <Translate value="ad_you_need" />
              </label>
            </div>

            <div className="col-md-12 form-group">
              <div className="row">
                <div className="col-md-4 text-center mt-15">
                  <h3 className="italic">{kindcommerce}:</h3>
                </div>
                <div className="col-xs-12 col-md-4 mt10 text-center">
                  <input
                    className="form-control text-center"
                    name="quantity"
                    type="number"
                    value={this.state.quantity}
                    onChange={this.onChangeQuantity}
                    max="100"
                    min="1"
                    disabled={this.props.ad.KindCommerceId !== 2}
                  />
                </div>
                <div className="col-md-4 col-xs-12 text-center goder-button">
                  <button
                    type="button"
                    data-toggle="tooltip"
                    title="Godiway"
                    onClick={this.onClickBuy.bind(this)}
                    className="btn btn-success"
                  >
                    <b>{asq_ad}</b>
                  </button>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}

        <div className="col-md-12 text-center">
          {
            (Number(this.props.ad.KindCommerceId) === 2 ||
              Number(this.props.ad.KindCommerceId) === 4) && (
            <h2 className="my-3">
              ${this.props.ad.Price}
              <small>{this.props.ad.Currency}</small>
            </h2>
          )}
        </div>

        <div className="col-12">
          {this.renderMoreDetail()}
            {
              JSON.stringify(this.props.user) !== "{}" &&
              this.props.ad.Store.Id && (
                <Link
                  to={link_marketstore}
                  className="ad-marketstore-row"
                  style={{ textDecoration: "none" }}
                >
                  <img
                    src={this.props.ad.Store.Logo}
                    className="ad-marketstore-row__logo"
                    alt={this.props.ad.Store.Name || "MarketStore"}
                  />
                  <div className="ad-marketstore-row__info">
                    <span className="ad-marketstore-row__label">
                      <Translate value="ad_marketstore" />
                    </span>
                    <span className="ad-marketstore-row__name">
                      {this.props.ad.Store.Name}
                    </span>
                  </div>
                </Link>
              )
            }
        </div>

        <div className="report-goder-container">
          <small>
            <span style={{ color: "#929292" }}>{this.props.ad.CreatedAt}</span>
          </small>
        </div>
        <div className="report-goder-container">
          <small className="report-goder">
            <Link
              to="#"
              onClick={() => {
                this.onOpenCloseModal();
              }}
            >
              <Translate value="ad_report_title" />
            </Link>
            <span style={{ color: "#929292" }}> {"  #"} {this.props.ad.Id}</span>
          </small>

        </div>
        <hr className="dividerGray" />
        <ModalReportAd
          isOpen={this.state.open_modal}
          onClose={() => {
            this.onOpenCloseModal();
          }}
        />
        <ModalShareAd
          isOpen={this.state.open_share_modal}
          onClose={this.onOpenCloseShareModal}
          ad={this.props.ad}
        />
        <ModalAuctionBid
          isOpen={this.state.open_bid_modal}
          onClose={this.onCloseBidModal}
          ad={this.props.ad}
        />
        <ModalCheckout
          isOpen={this.state.open_checkout_modal}
          onClose={this.onCloseCheckout}
          ad={this.props.ad}
          quantity={this.state.quantity}
          submitting={this.state.submitting}
          onConfirm={this.onConfirmCheckout}
        />
      </React.Fragment>
    );
  }
}

function mapStateToProps(reducer) {
  //  console.log(reducer);
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,

    ad: reducer.ad.item,
    error: reducer.ad.error,
    loading: reducer.ad.loading,

    user: reducer.session.auth,
    error_transaction: reducer.transactionPending.error_new,
  };
}
const mapDispatchToProps = (dispatch) => ({
  UpdateWishAd: (token, params) =>
    dispatch(actions_wish.updateItem({ token, params })),
  NewTransaction: (token, params) => dispatch(actions_transaction.newItem({ token, params }) //id, message, quantity, user_id, token
  ),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AdDetailAction)
);
/*
 < div className="text-center">
          <button className="btn btn-secondary">
          <FaSlackHash/><FaHashtag/><FaSlackHash/><FaHashtag/><FaSlackHash/>
          </button>
        </div >*/